<body class="route-non-ido">
  <!-- Table header -->
  <app-table-header
    [headerText]="CONSTANTS.WELCOME_TEXT"
    [filterDisabled]="!isFilterEnabled"
    [rightPadding]="5"
    [hasCollapsedPadding]="false"
    [hasAddItem]="false"
    [hasFilter]="false"
    [hasExcel]="false"
    (clearFilterEvent)="clearAllFilters()"
  ></app-table-header>
  <div class="add-route">
    <app-table-add-route
      (addRouteEvent)="addRoute($event)"
    ></app-table-add-route>
    <app-excel-icon (exportExcelEvent)="exportExcel()"></app-excel-icon>
  </div>
  <div class="route-non-ido-table-container">
    <!-- Table -->
    <table mat-table [dataSource]="dataSource" class="route-non-ido-table">
      <caption>
        Route Admin
      </caption>
      <!-- Route ID -->
      <ng-container [matColumnDef]="COLUMN_IDS.ROUTE">
        <th mat-header-cell *matHeaderCellDef id="headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.ROUTE"
            [control]="routeData.formControl"
            [maxLength]="3"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>
        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="route-headers"
          class="left-data-column"
        >
          <div>
            {{ admin?.loop ? admin.loop : "-" }}
          </div>
        </td>
      </ng-container>

      <!-- Assigned ADL's -->
      <ng-container [matColumnDef]="COLUMN_IDS.ADL">
        <th mat-header-cell *matHeaderCellDef id="headers">
          <ion-row class="th-text"> {{ COLUMNTEXT.ADL }} </ion-row>
          <ion-row class="search-wrapper">
            <div class="search-header-labels"></div>
          </ion-row>
        </th>
        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="assignedADLs-headers"
          class="left-data-column"
        >
          <a class="table-link" (click)="openEditAdl(i)">
            {{ admin?.adls?.length ?? 0 }}
          </a>
        </td>
      </ng-container>

      <!-- Actions -->
      <ng-container [matColumnDef]="COLUMN_IDS.ACTION">
        <th mat-header-cell *matHeaderCellDef>
          <ion-row class="th-text center">
            {{ COLUMNTEXT.ACTIONS }}
          </ion-row>
          <ion-row class="search-wrapper">
            <div class="search-header-labels"></div>
          </ion-row>
        </th>
        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="action-headers"
        >
          <app-table-action-cell
            [data]="admin"
            [hasEditButton]="false"
            [deleteButtonDisabled]="false"
            (emitDeleteButton)="removeRoute(i)"
          ></app-table-action-cell>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="IDS; sticky: true"></tr>

      <tr mat-row *matRowDef="let row; columns: IDS; let i = index"></tr>

      <tr class="mat-row no-data-row" *matNoDataRow>
        <td class="mat-cell no-border" [attr.colspan]="IDS.length">
          <app-no-results-found></app-no-results-found>
        </td>
      </tr>
    </table>
  </div>
  <app-table-pagination [datasource]="dataSource"></app-table-pagination>
</body>
